import { Fragment, useContext } from 'react';
import styled from 'styled-components';

const StyledSubtitle = styled.p`
	${(props) =>
		'separator' === props.format &&
		`
	
		align-items: center;
		display: flex;
		justify-content: center;
		min-height: 1rem;
	
		&:before,
		&:after {
			background-color: #000;
			content: '';
			flex-grow: 1;
			height: 1px;
		}

	`}
`;

export default function Subtitle({ label, format }) {
	return (
		<Fragment>
			{label && label.length && (
				<StyledSubtitle
					format={format}
					className={`container  slp-Section h4 slp-Subtitle ${
						'separator' === format ? 'slp-Separator' : ''
					}`}
				>
					<Fragment>
						&nbsp;
						{label}
						&nbsp;
					</Fragment>
				</StyledSubtitle>
			)}
		</Fragment>
	);
}
